var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 0.832031C14.2293 0.832031 18.3333 4.93609 18.3333 9.9987C18.3333 15.0613 14.2293 19.1654 9.16667 19.1654C4.10406 19.1654 0 15.0613 0 9.9987C0 4.93609 4.10406 0.832031 9.16667 0.832031ZM9.70139 9.9987H8.63194C8.29444 9.9987 8.02083 10.2723 8.02083 10.6098V13.9709C8.02083 14.3084 8.29444 14.582 8.63194 14.582H9.70139C10.0389 14.582 10.3125 14.3084 10.3125 13.9709V10.6098C10.3125 10.2723 10.0389 9.9987 9.70139 9.9987ZM9.70139 5.41536H8.63194C8.29444 5.41536 8.02083 5.68897 8.02083 6.02648V7.09592C8.02083 7.43343 8.29444 7.70703 8.63194 7.70703H9.70139C10.0389 7.70703 10.3125 7.43343 10.3125 7.09592V6.02648C10.3125 5.68897 10.0389 5.41536 9.70139 5.41536Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowInfo);
export default __webpack_public_path__ + "static/media/yellow-info.188ff18edd01291bcb8837b9a50272b9.svg";
export { ForwardRef as ReactComponent };